import { createFileRoute } from '@tanstack/react-router';

import { StationPage } from '../modules/station/ui/pages/StationPage';

// valet-keychain-qr D1 — station-auth. Deliberately a STANDALONE route (not
// under `_authenticated`) — spec "no personal valet login required": this
// route bypasses the operator-only login guard entirely and gates itself
// via the station's own device-token/session flow (useStationSession),
// never the operator auth-store.
export const Route = createFileRoute('/station')({
  component: StationPage,
});
